(() => {
  if (window.SnugBundleCart) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  let pending;
  let timer;
  let generation = 0;
  let loadedGeneration = -1;
  let current = null;
  const publish = (value) => {
    current = value;
    window.dispatchEvent(new CustomEvent('snug:bundle-cart', { detail: value }));
    return value;
  };
  const refresh = () => {
    if (pending) return pending.then((state) => loadedGeneration < generation ? refresh() : state);
    const requestedGeneration = generation;
    pending = nativeFetch(`${root()}?section_id=snug-bundle-cart-state`, {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' }
    }).then(async (response) => {
      if (!response.ok) throw new Error('Cart state unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = document.querySelector('[data-snug-bundle-cart-state]');
      if (!source) throw new Error('Cart state unavailable');
      const state = JSON.parse(source.textContent);
      const keys = new Set(state.eligibleKeys);
      state.eligibleCount = state.cart.items.reduce((sum, item) => sum + (keys.has(item.key) ? item.quantity : 0), 0);
      loadedGeneration = requestedGeneration;
      return publish(state);
    }).catch(() => { loadedGeneration = requestedGeneration; return publish(null); }).finally(() => { pending = null; });
    return pending;
  };
  const schedule = () => {
    generation += 1;
    clearTimeout(timer);
    timer = setTimeout(refresh, 50);
  };
  const isMutation = (url) => {
    try { return /\/cart\/(add|change|update|clear)(\.js|\.json)?$/.test(new URL(url, location.href).pathname); }
    catch { return false; }
  };
  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    if (isMutation(typeof args[0] === 'string' || args[0] instanceof URL ? args[0] : args[0]?.url)) schedule();
    return response;
  };
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    if (isMutation(url)) this.addEventListener('loadend', schedule, { once: true });
    return originalOpen.call(this, method, url, ...rest);
  };
  window.SnugBundleCart = { refresh, get current() { return current; }, rate: (count) => count >= 4 ? 10 : count >= 2 ? 5 : 0 };
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  refresh();
})();
